import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../API/axiosNeatex';
import type { APIResponse } from '@store/Shared/shared';

export interface ProjectContract {
  id: string;
  organizationId: string;
  partyId: string;
  partyName: string;
  partyName2: string;
  contractNo: string;
  contractType: string;
  signedDate: string;
  startDate: string;
  endDate: string;
  currency: string;
  totalAmount: number;
  advancePct: number;
  retentionPct: number;
  statusId: string;
  notes: string;
  contractLineList: ProjectContractLine[];
}

interface ProjectContractLine {
  id: string;
  contractId: string;
  lineNo: number;
  description: string;
  quantity: number;
  uom: string;
  unitPrice: number;
  amount: number;
  phaseId: string | null;
  taskId: string | null;
  costCategory: string | null;
}

export const addProjectContract = createAsyncThunk(
  'Project/addProjectContract',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post<APIResponse<string>>('Project/AddProjectContract', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateProjectContract = createAsyncThunk(
  'Project/updateProjectContract',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('Project/UpdateProjectContract', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const addProjectContractLine = createAsyncThunk(
  'Project/addProjectContractLine',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post<APIResponse<string>>('Project/AddProjectContractLine', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateProjectContractLine = createAsyncThunk(
  'Project/updateProjectContractLine',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('Project/UpdateProjectContractLine', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteProjectContractLine = createAsyncThunk(
  'Project/deleteProjectContractLine',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('Project/DeleteProjectContractLine', { id });
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// export const getContractsByProject = createAsyncThunk(
//   'Project/getContractsByProject',
//   async (projectId: string, { rejectWithValue }) => {
//     try {
//       const { data } = await ntxAPI.get(`Project/GetContractsByProject?projectId=${projectId}`);
//       if (data.succeeded === true) {
//         return data.data;
//       } else {
//         return [];
//       }
//     } catch (error: any) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

export const getContractsByProjectWithLine = createAsyncThunk(
  'Project/getContractsByProjectWithLine',
  async (projectId: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get(`Project/GetContractsByProjectWithLine?organizationId=${projectId}`);
      if (data.succeeded === true) {
        return data.data;
      } else {
        return [];
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState: {
  contracts: ProjectContract[];
  previousContracts: ProjectContract[];
  loading: boolean;
  error: any | null;
  contractLines: ProjectContractLine[];
  loading2: boolean;
  error2: any | null;
} = {
  contracts: [],
  previousContracts: [],
  loading: false,
  error: null,
  contractLines: [],
  loading2: false,
  error2: null
};

const projectContractSlice = createSlice({
  name: 'ProjectContract',
  initialState,
  reducers: {
    updateContractInList: (state, action: PayloadAction<{ contractId: string; updates: Partial<ProjectContract> }>) => {
      const { contractId, updates } = action.payload;
      const idx = state.contracts.findIndex(c => String(c.id) === String(contractId));
      if (idx !== -1) {
        state.contracts[idx] = { ...state.contracts[idx], ...updates };
      }
    },
    updateContractLineInList: (
      state,
      action: PayloadAction<{ lineId: string; updates: Partial<ProjectContractLine> }>
    ) => {
      const { lineId, updates } = action.payload;
      const idx = state.contractLines.findIndex(cl => String(cl.id) === String(lineId));
      if (idx !== -1) {
        state.contractLines[idx] = { ...state.contractLines[idx], ...updates };
      }
    },
    rollbackContracts: state => {
      state.contracts = state.previousContracts;
    }
  },
  extraReducers(builder) {
    builder
      // .addCase(getContractsByProject.pending, state => {
      //   state.loading = true;
      // })
      // .addCase(getContractsByProject.fulfilled, (state, action: PayloadAction<ProjectContract[]>) => {
      //   state.loading = false;
      //   state.contracts = action.payload;
      //   state.previousContracts = action.payload;
      // })
      // .addCase(getContractsByProject.rejected, (state, action: PayloadAction<any>) => {
      //   state.loading = false;
      //   state.error = action.payload;
      // })
      ////////
      .addCase(getContractsByProjectWithLine.pending, state => {
        state.loading = true;
      })
      .addCase(getContractsByProjectWithLine.fulfilled, (state, action: PayloadAction<ProjectContract[]>) => {
        state.loading = false;
        state.contracts = action.payload;
        state.previousContracts = action.payload;
      })
      .addCase(getContractsByProjectWithLine.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      ////////
  }
});

export const { updateContractInList, updateContractLineInList, rollbackContracts } = projectContractSlice.actions;
export default projectContractSlice.reducer;
